import React from 'react';

import Icon from '../Icon';

export const TunabilityOnIcon = (props) => {
    return (
        <Icon width='48' height='48' viewBox='0 0 32 32' fill='none' {...props}>
            <path
                d='M15.3046 17.7853V14.2156C15.3046 13.8314 15.6161 13.52 16.0003 13.52C16.3845 13.52 16.6959 13.8314 16.6959 14.2156V17.7853C16.6959 18.1695 16.3845 18.4809 16.0003 18.4809C15.6161 18.4809 15.3046 18.1695 15.3046 17.7853Z'
                className='fill-color-slate-gray group-[.active]:fill-color-slate-gray dark:fill-color-romance'
            />
            <path
                d='M15.3046 11.4305V7.86085C15.3046 7.47666 15.6161 7.1652 16.0003 7.1652C16.3845 7.1652 16.6959 7.47666 16.6959 7.86085V11.4305C16.6959 11.8147 16.3845 12.1261 16.0003 12.1261C15.6161 12.1261 15.3046 11.8147 15.3046 11.4305Z'
                className='fill-color-slate-gray group-[.active]:fill-color-slate-gray dark:fill-color-romance'
            />
            <path
                d='M15.3046 24.1401V20.5704C15.3046 20.1862 15.6161 19.8748 16.0003 19.8748C16.3845 19.8748 16.6959 20.1862 16.6959 20.5704V24.1401C16.6959 24.5243 16.3845 24.8357 16.0003 24.8357C15.6161 24.8357 15.3046 24.5243 15.3046 24.1401Z'
                className='fill-color-slate-gray group-[.active]:fill-color-slate-gray dark:fill-color-romance'
            />
            <path
                d='M21.2177 10.4348C21.2177 7.55329 18.8818 5.21738 16.0003 5.21738C13.1188 5.21738 10.7829 7.55329 10.7829 10.4348V21.5652L10.7846 21.6997C10.856 24.519 13.1638 26.7826 16.0003 26.7826C18.8368 26.7826 21.1446 24.519 21.216 21.6997L21.2177 21.5652V10.4348ZM22.609 21.5652C22.609 25.2151 19.6502 28.1739 16.0003 28.1739C12.3504 28.1739 9.3916 25.2151 9.3916 21.5652V10.4348C9.3916 6.78489 12.3504 3.82608 16.0003 3.82608C19.6502 3.82608 22.609 6.78489 22.609 10.4348V21.5652Z'
                className='fill-color-slate-gray group-[.active]:fill-color-slate-gray dark:fill-color-romance'
            />
        </Icon>
    );
};
